import { defineComponent as u, computed as b, openBlock as s, createElementBlock as l, createVNode as d, createElementVNode as t, toDisplayString as o, createBlock as g, unref as m, createCommentVNode as i, createTextVNode as v, renderSlot as c } from "vue";
import { RevTag as h } from "@ds/components/Tag";
import y from "../../icons/generated/IconEyeOpen.vue2.js";
import { useLocale as x } from "@ds/plugin";
import w from "./components/MessageAvatar.vue2.js";
const k = { class: "flex flex-row gap-12" }, p = { class: "grow" }, _ = { class: "mb-4 flex flex-col justify-center" }, $ = { class: "flex items-center justify-between gap-8" }, N = { class: "flex shrink grow-0 flex-col overflow-hidden sm:flex-row sm:gap-8" }, V = ["title"], B = {
  key: 0,
  class: "text-static-default-low body-1 shrink-0 grow basis-[7ch] self-start text-right md:self-end",
  "data-allow-mismatch": "text"
}, D = {
  key: 0,
  class: "text-static-default-low body-2-bold mt-4 flex items-center gap-4"
}, T = { class: "body-1 mb-16 whitespace-pre-line break-words" }, j = {
  key: 0,
  class: "mb-16 grid grid-cols-1 gap-16 lg:grid-cols-3"
}, F = /* @__PURE__ */ u({
  name: "RevMessage",
  __name: "Message",
  props: {
    variant: {},
    label: {},
    tag: {},
    timestamp: {},
    visibility: {}
  },
  setup(e) {
    const r = e, f = x(), n = b(() => r.timestamp && Intl.DateTimeFormat(f.value, {
      hour: "2-digit",
      minute: "2-digit"
    }).format(r.timestamp));
    return (a, z) => (s(), l("article", k, [
      d(w, {
        class: "mt-4 shrink-0",
        label: e.label,
        variant: e.variant
      }, null, 8, ["label", "variant"]),
      t("div", p, [
        t("div", _, [
          t("div", $, [
            t("div", N, [
              t("div", {
                class: "text-static-default-hi body-1-bold truncate",
                title: e.label
              }, o(e.label), 9, V),
              e.tag ? (s(), g(m(h), {
                key: 0,
                class: "ml-0 mr-auto mt-2",
                label: e.tag,
                size: "medium",
                variant: "secondary"
              }, null, 8, ["label"])) : i("", !0)
            ]),
            n.value ? (s(), l("time", B, o(n.value), 1)) : i("", !0)
          ]),
          e.visibility ? (s(), l("div", D, [
            d(m(y), { size: "20" }),
            v(o(e.visibility), 1)
          ])) : i("", !0)
        ]),
        t("div", T, [
          c(a.$slots, "default")
        ]),
        a.$slots.documents ? (s(), l("div", j, [
          c(a.$slots, "documents")
        ])) : i("", !0),
        c(a.$slots, "appendix")
      ])
    ]));
  }
});
export {
  F as default
};
